import { useMemo } from 'react'
import RiveComponent, { RiveFit } from '../../RiveComponent'
import { shouldUseBlackWaveLoaderBackground } from '../../../utils/wavePageLoaderConfig'

enum BackgroundColor {
  BLACK = 'black',
  WHITE = 'white'
}

export const WavePageLoader = () => {
  const pathname = window?.location?.pathname ?? ''
  const backgroundColor = useMemo(() => {
    if (shouldUseBlackWaveLoaderBackground(pathname)) {
      return BackgroundColor.BLACK
    }
    return BackgroundColor.WHITE
  }, [pathname])

  return (
    <div style={{ backgroundColor: backgroundColor }} className='fixed inset-0 h-[100dvh] w-full relative overflow-hidden' aria-hidden >
      <WaveRiveWrapper backgroundColor={backgroundColor} />
    </div>
  )
}

export const WaveRiveWrapper = ({ backgroundColor }: { backgroundColor: BackgroundColor }) => {
  return (
    <div className="absolute top-0 left-0 w-[100vw] h-[900px] overflow-hidden" style={{ backgroundColor: backgroundColor }}>
      <RiveComponent
        src='/rives/bridge-loaders/bg_loader.riv'
        fit={RiveFit.FILL}
        fallback={<div className="bg-transparent" />}
      />
    </div>
  )
}
